import React from "react";
import { AlertCircle, User, Users } from "lucide-react";
import moment from "moment";

export const formatDate = (date) =>
  date ? moment(date).format("DD-MM-YYYY") : "-";

export const formatCurrency = (amount) =>
  amount ? `€${parseFloat(amount).toFixed(2)}` : "€0.00";

export const TAB_OPTIONS = [
  { value: "paymentsDue", label: "Payments Due", icon: <AlertCircle size={16} /> },
  { value: "patient", label: "Patient Payments", icon: <User size={16} /> },
  { value: "family", label: "Family Payments", icon: <Users size={16} /> },
];

export const FILTERS_CONFIG = [
  { id: "startDate", label: "Start Date", type: "date" },
  { id: "endDate", label: "End Date", type: "date" },
];
